module.exports = __webpack_public_path__ + "static/img/JEVAN-PHILLIPOU.7c8e594.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JEVAN-PHILLIPOU.jpg
// module id = 6WHq
// module chunks = 0